import { Outlet } from 'react-router-dom';

import { FoundationForecastingSidebar } from '@/components/layout/FoundationForecasting/FoundationForecastingSidebar';
import { DemandForecastingPairProvider } from '@/features/forecasts/providers/DemandForecastingPair';

export function FoundationForecastingLayout() {
  return (
    <DemandForecastingPairProvider>
      <div className="flex flex-1 min-w-0 overflow-hidden">
        <FoundationForecastingSidebar />
        <main className="flex-1 min-w-0 flex flex-col">
          <Outlet />
        </main>
      </div>
    </DemandForecastingPairProvider>
  );
}
